<template>
  <div>
    <ModalBasic
      v-if="modal_show.impressum"
      @close="close('impressum')"
    >
      <template v-slot:header>
        <h1 class="text-danger modal-header-h1">
          Impressum
        </h1>
      </template>
      <template v-slot:body>
        <Impressum />
      </template>
      <template v-slot:footer>
        <button
          class="btn btn-info modal-default-button"
          @click="close('impressum')"
        >
          Schließen
        </button>
      </template>
    </ModalBasic>

    <ModalBasic
      v-if="modal_show.privacy"
      @close="close('privacy')"
    >
      <template v-slot:header>
        <h1 class="text-danger modal-header-h1">
          Datenschutzerklärung
        </h1>
      </template>
      <template v-slot:body>
        <PrivacyPolicy />
      </template>

      <template v-slot:footer>
        <button
          class="btn btn-info modal-default-button"
          @click="close('privacy')"
        >
          Schließen
        </button>
      </template>
    </ModalBasic>


    <ModalBasic
      v-if="modal_show.cookie_banner"
      @close="close('cookie_banner')"
    >
      <template v-slot:header>
        <h1 class="text-danger modal-header-h1" style="font-size: 21px;">
          Wir verwenden Cookies
        </h1>
      </template>
      <template v-slot:body>
        <CookieDialog @close="close('cookie_banner')" />
      </template>
      <template v-slot:footer>
        <button
          class="btn btn-info modal-default-button"
          @click="close('cookie_banner')"
        >
          Schließen
        </button>
      </template>
    </ModalBasic>


    <MainTopNavBar />

    <header>
      <div class="container">
        <div class="row">
          <div class="col-xs-6">
            <h1 style="display:none;">
              gårdsfabriken - Webentwicklung
            </h1>
            <!-- <a href="index.html"><img src="img/logo.png" alt="Logo"></a> -->
            <!--</div>
          <div class="col-xs-6 signin text-right navbar-nav">
            <a
              href="#be-the-first"
              class="scroll">Unser Angebot</a>&nbsp; &nbsp;
            <a href="#about">Über uns</a>-->
          </div>
        </div>

        <div class="row header-info">
          <div class="col-sm-10 col-sm-offset-1 text-center">
            <h3 class="wow fadeIn">
              <img
                class="webhosting_img"
                alt="gårdsfabriken webhosting"
                src="img/webhosting-entwicklung.png"
                style="margin-bottom: 70px"
              >
            </h3>
            <p
              class="lead wow fadeIn"
              data-wow-delay="0.5s"
            >
              Ich bringe Ihre Ideen online,
              <br>ganz nach Ihren Wünschen.
            </p>
            <br>

            <div class="row">
              <div class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
                <div class="row">
                  <div
                    class="col-xs-6 text-right wow fadeInUp"
                    data-wow-delay="1s"
                  >
                    <a
                      href="#be-the-first"
                      class="btn btn-secondary btn-lg scroll"
                    >Mehr erfahren</a>
                  </div>
                  <div
                    class="col-xs-6 text-left wow fadeInUp"
                    data-wow-delay="1.4s"
                  >
                    <a
                      href="#invite"
                      class="btn btn-primary btn-lg scroll"
                    >Kontakt</a>
                  </div>
                </div>
                <!--End Button Row-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="mouse-icon hidden-xs">
      <div class="scroll" />
    </div>

    <section
      id="be-the-first"
      class="pad-xl"
    >
      <div class="container">
        <div class="row">
          <div
            class="col-sm-8 col-sm-offset-2 text-center margin-30 wow fadeIn"
            data-wow-delay="0.6s"
          >
            <h2>Mein Angebot</h2>
            <p
              class="lead"
            >
              Für Start-Ups, Freelancer, Kleinunternehmen, sowie auch Schulen, Lehrkräfte und andere kreative Köpfe.
            </p>
          </div>
        </div>

        <div
          class="iphone wow fadeInUp"
          data-wow-delay="1s"
        >
          <img src="img/apple-family.png">
        </div>
      </div>
    </section>

    <section
      id="main-info"
      class="pad-xl"
    >
      <div class="container">
        <div class="row">
          <div
            class="col-sm-6 wow fadeIn"
            data-wow-delay="0.4s"
          >
            <hr class="line green-light ">
            <h3>
              <i
                class="dev-bullets fa fa-server"
                aria-hidden="true"
              />Webhosting & Webdesign
            </h3>
            <p>In Kooperation mit einer Grafikerin designe ich Ihnen eine Webseite nach Ihren Wünschen, richte diese ein und garantiere Ihnen, diese langfristig auf dem Laufenden zu halten.</p>
          </div>

          <div
            class="col-sm-6 wow fadeIn"
            data-wow-delay="1.2s"
          >
            <hr class="line green-dark">
            <h3>
              <i
                class="dev-bullets fa fa-code"
                aria-hidden="true"
              />Webentwicklung
            </h3>
            <p>Sie haben ein kleines Programm, eine Demonstrationsanwendnung, ein Lernspiel, oder ähnliches? Um es zur Verfügung zu stellen, möchten Sie es nun als Webseite oder Webanwendung online stellen? Kein Problem! Nach Wunsch, geben ich Ihrer Anwendung auch einen neuen Anstrich, sodass sie das gebührende Interesse auf sich zieht.</p>
          </div>

          <div
            class="col-sm-6 wow fadeIn"
            data-wow-delay="1.2s"
          >
            <hr class="line green-very-dark">
            <h3>
              <i
                class="dev-bullets fa fa-database"
                aria-hidden="true"
              />Daten und Datenbanken
            </h3>
            <p>Datenmigration</p>
            <p>Unterstützung mit SQL Datenbanken</p>
          </div>
          <div
            class="col-sm-6 wow fadeIn"
            data-wow-delay="1.2s"
          >
            <hr class="line black">
            <h3>
              <i
                data-v-fae5bece=""
                aria-hidden="true"
                class="dev-bullets fa fa-linux"
              />Linux und Bash
            </h3>
            
            

            <p>- Linuxsysteme sind mir bekannt</p>
            <p>- Shell Skript, Systemadministration</p>
            
            <p />
          </div>
        </div>
      </div>
    </section>

    <!--Über mich-->
    <section
      id="about"
      class="pad-lg"
    >
      <div class="container">
        <div class="row margin-40">
          <div class="col-sm-8 col-sm-offset-2 text-center">
            <h2 class="white">
              Über mich
            </h2>
            <p class="white" />
          </div>
        </div>

        <div class="row">
          <div
            class="col-sm-8 col-sm-offset-2 text-center margin-30 wow fadeIn"
            data-wow-delay="1s"
          >
            <br>
            
            
            <ul class="list-unstyled about-table text-center">
              <li class="headline">
                <a
                  target="_blank"
                  href="https://www.linkedin.com/in/benjamin-manns-91aa4a108/"
                >
                  <h2 class="white">
                    <vue-avatar
                      :username="'Franck Zappatta'"
                      src="img/AVATAR2.jpeg"
                    /> 
                    <span
                      style="display: inline-block;
    margin: -31px 0 0px 12px;
    position: relative;"
                    >Benjamin </span>

                    
                  </h2>
                </a>
              </li>
              <li class="price">
                <h5 class="amount">
                  Informatiker, Mathematiker
                </h5>
              </li>
              <li class="info">
                seit 7 Jahren im Bereich der Webentwicklung tätig
              </li>
              <li class="features first">
                Begeisteter VueJS Entwickler.
              </li>
              <li class="features">
                Daten und Datenbanken als Leidenschaft.
              </li>
              <li class="features">
                Weiterbildung in <a href="https://linux.org/">Linux</a>, <a href="https://en.wikipedia.org/wiki/Bash_(Unix_shell)">Bash</a> durch <a href="http://kamiware.org">Kamiware (http://kamiware.org/)</a>.
              </li>
              <li class="features">
                Erfahrung mit Python u.a. im Bereich Datamining.
              </li>
              <li class="features">
                Offizieller <a href="https://www.joomla.org/">Joomla</a> Contributor. 
              </li>

              <li class="features last btn btn-secondary btn-wide">
                <a href="#invite">Anfrage schicken</a>
              </li>
            </ul>
          </div>

          
          <!--  <div
            class="col-sm-6 about-container wow fadeInUp"
            data-wow-delay="1.3s"
          >
            <br>
            <ul class="list-unstyled about-table text-center">
              <li class="headline">
                <h2 class="white">
                  Désirée
                </h2>
              </li>
              <li class="price">
                <h5 class="amount">
                  Germanistikstudentin, Hobbygrafikerin
                </h5>
              </li>
              <li class="info">
                2 row section for you package information. You can include all details or icons
              </li>
              <li class="features first">
                Up To 25 Projects
              </li>
              <li class="features">
                10GB Storage
              </li>
              <li class="features">
                Other info
              </li>
              <li class="features last btn btn-secondary btn-wide">
                <a href="#">Get Started</a>
              </li>
            </ul>
          </div>-->
        </div>
      </div>
    </section>

    <section
      id="past-project"
      class="pad-xl"
    >
      <div class="container">
        <div class="row">
          <div
            class="col-sm-8 col-sm-offset-2 text-center margin-30 wow fadeIn"
            data-wow-delay="0.6s"
          >
            <h2>Letzte Projekte</h2>
          </div>
        </div>
        <div
          class="wow  fadeInUp"
          data-wow-delay="1s"
        >
          <carousel
            :per-page="1"
            :loop="true"
            :autoplay-timeout="6000" 
            direction="up"
            :autoplay="true"
          >
            <slide>
              <a
                target="_blank"
                href="https://gruen-gepflegt.de/"
              >
                <img
                  width=""
                  class="shadowed_images"
                  src="img/projects/gruengepflegt.jpg"
                >
              </a>
            </slide>
            <slide>
              <a
                target="_blank"
                href="https://kaefolution.gardsfabriken.de/"
              >
                <img
                  width=""
                  class="shadowed_images"
                  src="img/projects/kaefolution.png"
                >
              </a>
            </slide>
            <slide>
              <a
                target="_blank"
                href="https://feedback.mni.thm.de/"
              >
                <img
                  width=""
                  class="shadowed_images"
                  src="img/projects/feedbacksystem.png"
                >
              </a>
            </slide>
            <slide>
              <a
                target="_blank"
                href="#"
              >
                <img
                  width=""
                  class="shadowed_images"
                  src="img/projects/geoapp.png"
                >
              </a>
            </slide>
            <slide>
              <a
                target="_blank"
                href="#"
              >
                <img
                  width=""
                  class="shadowed_images"
                  src="img/projects/selective.png"
                >
              </a>
            </slide>
            <!--<slide>
              <h3>Nun sind Sie an der Reihe ... :)</h3>
            </slide>-->
          </carousel>
          <br>
          <br>
          <br>
          <br>
        </div>
      </div>
    </section>




    <section
      id="invite"
      class="pad-lg light-gray-bg"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-sm-offset-2 text-center">
            <i class="fa fa-envelope-o margin-40" />
            <h2 class="black">
              Schreiben Sie mir eine Anfrage
            </h2>
            <br>
            <p
              class="black"
            >
              Ich bin gespannt auf Ihre Ideen und schicke Ihnen ein auf Ihre Wünsche zugeschnittenes Angebot zu.
            </p>
            <br>

            <Contact />
          </div>
        </div>
      </div>
    </section>

    <!-- <section id="press" class="pad-sm">
      <div class="container">
        
        <div class="row margin-30 news-container">
          <div class="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 wow fadeInLeft" data-wow-delay="0.8s">
            <a href="#" target="_blank">
            <img class="news-img pull-left" src="img/press-01.jpg" alt="Tech Crunch">
            <p class="black">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam viverra orci ut.<br /> 
            <small><em>Tech Crunch - January 15, 2015</em></small></p>
            </a>
          </div>
        </div>
        
        <div class="row margin-30 news-container">
          <div class="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 wow fadeInLeft" data-wow-delay="1.2s">
            <a href="#" target="_blank">
            <img class="news-img pull-left" src="img/press-02.jpg" alt="Forbes">
            <p class="black">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam viverra orci ut. <br /> 
            <small><em>Forbes - Feb 25, 2015</em></small></p>
            </a>
          </div>
        </div>
        
      </div>
    </section>-->

   
    <div class="container">
      <div class="row margin-40">
        <div class="col-sm-8 col-sm-offset-2 text-center">
          <h2 class="white">
            Weiteres
          </h2>
            
          <p class="white">
            <ul />
          </p>
        </div>
      </div>

      <div class="row">
        <div />
      </div>
    </div>
    
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-sm-8 margin-20">
            <ul class="list-inline social">
              <li>
                <a
                  href="https://github.com/bees4ever"
                  title="GitHub @bees4ever"
                  target="_blank"
                  style="color: #419f8a;"
                >
                  <svg
                    height="20"
                    class="octicon octicon-mark-github d-block"
                    alt="GitHub"
                    viewBox="0 0 16 16"
                    version="1.1"
                    width="20"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/iceworldstudio"
                  title="Twitter Account"
                  target="_blank"
                  style="color: black;"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 273.5 222.3"
                    class="d-block"
                    height="18"
                  >
                    <path
                      d="M273.5 26.3a109.77 109.77 0 0 1-32.2 8.8 56.07 56.07 0 0 0 24.7-31 113.39 113.39 0 0 1-35.7 13.6 56.1 56.1 0 0 0-97 38.4 54 54 0 0 0 1.5 12.8A159.68 159.68 0 0 1 19.1 10.3a56.12 56.12 0 0 0 17.4 74.9 56.06 56.06 0 0 1-25.4-7v.7a56.11 56.11 0 0 0 45 55 55.65 55.65 0 0 1-14.8 2 62.39 62.39 0 0 1-10.6-1 56.24 56.24 0 0 0 52.4 39 112.87 112.87 0 0 1-69.7 24 119 119 0 0 1-13.4-.8 158.83 158.83 0 0 0 86 25.2c103.2 0 159.6-85.5 159.6-159.6 0-2.4-.1-4.9-.2-7.3a114.25 114.25 0 0 0 28.1-29.1"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/benjamin-manns-91aa4a108/"
                  target="_blank"
                  style="color: #419f8a;"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-8 margin-20">
            <ul class="list-inline social">
              <li>
                <a
                  class="clickable"
                  @click="show('impressum')"
                >Impressum</a>
              </li>
              <li>
                <a
                  class="clickable"
                  @click="show('privacy')"
                >Datenschutz</a>
              </li>
            </ul>
          </div>

          <div class="col-sm-4 text-right">
            <p>
              <small>
                Copyright &copy; {{ (new Date()).getFullYear() }}. All rights reserved.
                <br>
              </small>
            </p>
          </div>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
// @ is an alias to /src
import Contact from "@/components/Contact.vue";
import CookieDialog from "@/components/CookieDialog.vue";
import ModalBasic from "@/components/ModalBasic.vue";
import Impressum from "@/components/Impressum.vue";
import PrivacyPolicy from "@/components/PrivacyPolicy.vue";
import MainTopNavBar from "@/components/MainTopNavBar.vue";
import VueAvatar from '@lossendae/vue-avatar'

export default {
  name: "Home",
  components: {
    Contact,
    ModalBasic,
    Impressum,
    PrivacyPolicy,
    MainTopNavBar,
    VueAvatar,
    CookieDialog
  },
  data() {
    return {
      modal_show: {
        impressum: false,
        privacy: false,
        cookie_banner: true
      }
    };
  },
  methods: {
    show(type) {
      this.modal_show[type] = true;
    },
    close(type) {
      this.modal_show[type] = false;
    }
  }
};
</script>


<style scoped>
.dev-bullets{
font-size: 40px;
margin: 4px 5px;
position: relative;
}
.clickable {
  cursor: pointer;
}
.shadowed_images {
  max-width: 100%;

    margin-left: auto;
    margin-right: auto;

    display: block;




  /*margin-left: 10%;*/
  /*-webkit-box-shadow: 10px 10px 46px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 10px 46px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 10px 46px 0px rgba(0, 0, 0, 0.75);*/
}
@media only screen and (max-width: 400px) {
  .lead {
    margin-left: 0;
  }
  .webhosting_img {
    width: 320px;
  }
  .top_logo {
    background: black;
    width: 100%;
  }
}
</style>
